import { render, staticRenderFns } from "./InputEvent.vue?vue&type=template&id=08fcad22&scoped=true"
import script from "./InputEvent.vue?vue&type=script&lang=js"
export * from "./InputEvent.vue?vue&type=script&lang=js"
import style0 from "./InputEvent.vue?vue&type=style&index=0&id=08fcad22&prod&lang=scss&scoped=true"
import style1 from "./InputEvent.vue?vue&type=style&index=1&id=08fcad22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fcad22",
  null
  
)

export default component.exports